import Client from '../axiosAuthClient'
const resource = '/login';
const logoutResource = '/logout';
const passwordResource = '/password';
const registerResource = '/register';
const resetTokenValidationResource = '/validate-password-reset';
/*const resetPasswordResource = '/reset';*/
const resetPasswordResource = '/change-password';
const socialLoginResource = '/social/login';
const emailVerificationResource = '/email-verification';
const config = '/config';
const partnerLogin = '/partner/access';
const salesLogin = '/sales/access';
const adminLogin = '/partner/admin/access';
const getOtp = '/get-otp';

export default {
  post(payload) {
    return Client.post(`${resource}`, payload);
  },

  logout() {
    return Client.post(`${logoutResource}`);
  },

  password(payload) {
    return Client.post(`${passwordResource}`, payload);
  },
  getOTP(payload) {
    return Client.post(`${getOtp}`, payload);
  },

  register(payload) {
    return Client.post(`${registerResource}`, payload);
  },

  resetTokenValidation(payload) {
    return Client.post(`${resetTokenValidationResource}`, payload);
  },

  resetPassword(payload) {
    return Client.post(`${resetPasswordResource}`, payload);
  },

  socialLogin(payload) {
    return Client.post(`${socialLoginResource}`, payload);
  },

  emailVerification(payload) {
    return Client.post(`${emailVerificationResource}`, payload);
  },

  getConfig() {
    return Client.get(`${config}`);
  },

  partnerLogin(payload) {
    return Client.post(`${partnerLogin}`, payload);
  },
  salesLogin(payload) {
    return Client.post(`${salesLogin}`, payload);
  },

  backToAdmin(payload) {
    return Client.post(`${adminLogin}`, payload);
  }

  // MANY OTHER ENDPOINT RELATED STUFFS
};



// WEBPACK FOOTER //
// ./src/repositories/auth/authRepository.js